<template>
  <div class="card is-min-width-700"
    v-if="!chargement && demandesLogistique">
    <header class="bandeau-modal card-header">
    </header>
    <div class="pdl-20px pdr-20px">
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-40px">
            <h1 class="title is-size-3">
              <span>
                {{ $t('demandeLogistique.patrimoine.title') }}
              </span>
            </h1>
          </div>
        </div>
      </div>
      <div class="card-content pdl-0 pdr-0">
        <div class="columns is-multiline mgt-20px">
          <div class="column is-12">
            <information-patrimoine
              :faceId="face ? face.id : ''"
              :materielId="materiel ? materiel.id : ''"
              :dispositifId="dispositif ? dispositif.id : ''"
              :emplacementId="emplacement ? emplacement.id : ''">
            </information-patrimoine>
          </div>
          <div class="column is-12">
            <div class="columns is-marginless is-vcentered ">
              <div class="column has-text-default ">
                <qd-switch v-model="voirAncienne">
                  {{$t('demandeLogistique.patrimoine.afficherAncienne')}}
                </qd-switch>
              </div>
            </div>
          </div>
          <div class="column is-12" v-if="!demandesFiltrees || demandesFiltrees.length == 0">
            <div class="columns is-marginless is-vcentered border-color-select ">
              <div class="column has-text-weight-bold has-text-default has-text-centered">
                {{$t('demandeLogistique.patrimoine.aucuneDemande')}}
              </div>
            </div>
          </div>
          <div class="column is-12 columns is-multiline is-marginless  modal-hauteur-max-50vh">
            <div class="column is-paddingless is-12 "
              :class="{'mgt-20px': $index != 0}"
              v-for="(demande, $index) in demandesFiltrees" :key="$index">
              <div class="columns is-marginless is-vcentered border-color-select"
                :class="{'faceAvecDemande': estDemandeSemaineCourante(demande)}">
                <div class="column pdl-20px">
                  <b-field :label="$t('demandeLogistique.patrimoine.demande')">
                    <span class="is-size-7 has-text-default">
                      {{ demande.actionLogistique }}
                    </span>
                  </b-field>
                </div>
                <div class="column is-narrow">
                  <b-field :label="$t('demandeLogistique.patrimoine.date')">
                    <span class="is-size-7 has-text-default">
                      {{ demande.datePlanification | formatDate }}
                    </span>
                  </b-field>
                </div>
                <div class="column is-2">
                  <b-field :label="$t('demandeLogistique.patrimoine.etat')">
                    <span class="is-size-7 has-text-default">
                      {{ $t(importedFunction.getEtatDemande(demande)) }}
                    </span>
                  </b-field>
                </div>
                <div class="column is-2">
                  <b-field :label="$t('demandeLogistique.patrimoine.typeDemande')">
                    <span class="is-size-7 has-text-default">
                      {{ getLibelleTypeIntervention(demande.type) }}
                    </span>
                  </b-field>
                </div>
                <div class="column is-2">
                  <div v-if="demande.ots && demande.otsAffichages.length ==1">
                    <router-link-blank :to="{ name: 'c.logistique.ordre_travail-affichage',
                      params: { id: demande.otsAffichages[0].id } }"
                      class="lien"
                      :message="demande.otsAffichages[0].code">
                    </router-link-blank>
                  </div>
                </div>
                <div class="column is narrow">
                  <a @click=" popupSupp(demande)" class="is-pulled-right column is-narrow">
                    <b-icon
                      icon="delete-forever"
                      type="is-danger"
                      :class="{ 'text-access-no-permission'
                      : !checkPermissions(permDemande.supprimer) || demande.estDansOtAffichage}">
                    </b-icon>
                  </a>
                  <a @click=" popupUpdate(demande)" class="is-pulled-right column is-narrow">
                    <b-icon
                      icon="pencil-box-outline"
                      type="is-success"
                      :class="{ 'text-access-no-permission'
                      : !checkPermissions(permDemande.maj) || demande.estDansOtAffichage}">
                    </b-icon>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-12 boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('general.button.close')}}
            </a>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="popUpSuppression" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="this.$t('demandeLogistique.popUpSuppression.title')"
        :messDescription="this.$t('demandeLogistique.popUpSuppression.message')"
        :cancel="this.$t('general.non')"
        :validate="this.$t('general.oui')"
        @no="popUpSuppression = false"
        @yes="deleteDemande"/>
    </b-modal>
    <b-modal v-model="popUpModificationCreation" has-modal-card class="modal">
        <modificationDemande
          @refreshList="refreshList"
          :demandeLogistique="ligneAModifier"
          :agenceId="ligneAModifier ? ligneAModifier.agenceId : ''"
          :face="face" >
        </modificationDemande>
    </b-modal>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import moment from 'moment';
import informationPatrimoine from '@/components/gabed/general/informationPatrimoine';
import { DEMANDE } from '@/configuration/logistique/permissionsLogistiqueConf';
import messageSucces from '@/services/general/messageSucces';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import messageErreur from '@/services/general/messageErreur';
import formatIsoDate from '@/services/general/formatIsoDate';
import getEtatDemande from '@/services/logistique/demandeLogistique/getEtatDemandeLogistique';
import { getAll as getAllDemandeLogistique, deleteDemandeLogistique } from '@/api/logistique/demandeLogistique/index';
import getAnneeSemaineFromDate from '@/services/general/getAnneeSemaineFromDate';
import popUpPrevention from '@/components/general/popUpPrevention';
import {
  INTERVENTION_TYPE_AFFICHAGE, INTERVENTION_TYPE_INTERVENTION, TYPE_INTERVENTION,
} from '@/configuration/logistique/intervention/interventionConf';
import modificationDemande from './p_editionDemande';

const societe = createNamespacedHelpers('societe');
const Permissions = createNamespacedHelpers('permissions');

export default {
  name: 'p_creationDemande',
  props: {
    face: {
      type: Object,
      required: false,
    },
    materiel: {
      type: Object,
      required: false,
    },
    dispositif: {
      type: Object,
      required: false,
    },
    emplacement: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      permDemande: DEMANDE,
      demandeASupp: null,
      creationDemandeParametre: {
        datePlanification: moment().toDate(),
        actionLogistique: '',
      },
      importedFunction: {
        adressFullStringGetter,
        getEtatDemande,
      },
      chargement: false,
      demandesLogistique: null,
      voirAncienne: false,
      popUpSuppression: false,
      popUpModificationCreation: false,
      ligneAModifier: null,
    };
  },
  components: {
    informationPatrimoine,
    routerLinkBlank,
    popUpPrevention,
    modificationDemande,
  },
  computed: {
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    demandesFiltrees() {
      if (this.voirAncienne) {
        return this.demandesLogistique;
      }
      const dateDebut = formatIsoDate(moment().weekday(0).toDate());
      return this.demandesLogistique.filter(d => {
        return dateDebut <= d.datePlanification;
      });
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    async getAllDemandeLogistiqueAsync() {
      const param = {
        query: {
          produitIds: this.face ? [this.face.produitId] : [],
          materielIds: this.materiel ? [this.materiel.id] : [],
          dispositifIds: this.dispositif ? [this.dispositif.id] : [],
          emplacementIds: this.emplacement ? [this.emplacement.id] : [],
          societeId: this.societeActiveId,
          types: [INTERVENTION_TYPE_AFFICHAGE, INTERVENTION_TYPE_INTERVENTION],
        },
      };
      const demandes = (await getAllDemandeLogistique(param)).data.result.items;
      if (demandes) {
        this.demandesLogistique = demandes;
      }
    },
    refreshList(demande) {
      const demandeEcran = this.demandesLogistique.find(d => {
        return d.id === demande.id;
      });
      if (!demandeEcran) {
        this.demandesLogistique.push(demande);
      } else {
        demandeEcran.datePlanification = demande.datePlanification;
        demandeEcran.actionLogistique = demande.actionLogistique;
      }
      this.tri();
    },
    estDemandeSemaineCourante(demande) {
      return getAnneeSemaineFromDate(demande.datePlanification)
      === getAnneeSemaineFromDate(moment().toDate());
    },
    tri() {
      this.demandesLogistique = this.demandesLogistique.sort((a, b) => {
        return new Date(a.datePlanification) - new Date(b.datePlanification);
      });
    },
    popupSupp(demande) {
      if (!this.checkPermissions(this.permDemande.supprimer) || demande.estDansOtAffichage) {
        return;
      }
      this.demandeASupp = demande;
      this.popUpSuppression = true;
    },
    popupUpdate(demande) {
      if (!this.checkPermissions(this.permDemande.maj) || demande.estDansOtAffichage) {
        return;
      }
      this.ligneAModifier = demande;
      this.popUpModificationCreation = true;
    },
    async deleteDemande() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await deleteDemandeLogistique(this.demandeASupp.id);
        const indexDemandeASupp = this.demandesLogistique.findIndex(d => {
          return this.demandeASupp.id === d.id;
        });
        if (indexDemandeASupp > -1) {
          this.demandesLogistique.splice(indexDemandeASupp, 1);
        }
        this.demandeASupp = null;
        this.popUpSuppression = false;
        loadingComponent.close();
        messageSucces(this.$i18n.t('demandeLogistique.popUpSuppression.success'));
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    getLibelleTypeIntervention(typeInt) {
      const typeIntFind = TYPE_INTERVENTION.find((type) => {
        return type.key === typeInt;
      });
      return typeIntFind ? this.$i18n.t(typeIntFind.libelle) : null;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    this.chargement = true;
    try {
      await this.getAllDemandeLogistiqueAsync();
      this.tri();
      this.chargement = false;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      this.chargement = false;
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
